module.exports = __webpack_public_path__ + "static/media/under-construction.05111ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/PNGs/under-construction.png
// module id = 256
// module chunks = 0